// extracted by mini-css-extract-plugin
export default {"information":"style_information__+ogQu","title":"style_title__stet1"};